export const CREATE_APPLICATION = 'CREATE_APPLICATION';
export const UPDATE_APPLICATION = 'UPDATE_APPLICATION';
export const DELETE_APPLICATION = 'DELETE_APPLICATION';
export const FETCH_APPLICATIONS = 'FETCH_APPLICATIONS';
export const FETCH_ALL_APPLICATIONS = 'FETCH_ALL_APPLICATIONS';
export const LISTEN_TO_SELECTED_APPLICATION = 'LISTEN_TO_SELECTED_APPLICATION';
export const LISTEN_TO_APPLICATION_PHOTOS = 'LISTEN_TO_APPLICATION_PHOTOS';
export const CLEAR_APPLICATIONS = 'CLEAR_APPLICATIONS';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_LEVEL = 'SET_LEVEL';
export const SET_MEDIA_TYPE = 'SET_MEDIA_TYPE';
export const RETAIN_STATE = 'RETAIN_STATE';
export const FETCH_REVIEWS = 'FETCH_REVIEWS';
export const FETCH_AFFILIATE_LINK = 'FETCH_AFFILIATE_LINK';
export const SET_SHOW_GENERIC = 'SET_SHOW_GENERIC';
